export default class DownloadBase64 {
    static downloadPDF(dataBase64, fileName) {
        const arraybuffer = this.base64ToArrayBuffer(dataBase64);
        const blob = new Blob([arraybuffer], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);

        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = `${fileName}.pdf`;
        downloadLink.click();
    }

    static base64ToArrayBuffer(base64) {
        // decode base64 string, remove space for IE compatibility
        const binaryString = window.atob(base64.replace(/\s/g, ''));
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i += 1) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }
}
